// extracted by mini-css-extract-plugin
export default {"container":"FlagIcons_container__czDJD","selected":"FlagIcons_selected__38G2B"};